import Image from 'next/image';
import useTranslation from 'next-translate/useTranslation';

import styles from './store-list.module.scss';

const StoreList = ({ links }) => {
  const { t } = useTranslation();

  const renderStore = (item, index) => {
    return (
      <a
        className={styles.link}
        href={item?.link}
        key={index}
        target={'_blank'}
        rel='noopener noreferrer'
        itemScope
        itemType='https://schema.org/LinkRole'
      >
        <Image
          src={item.image}
          alt={t('common:Download our app')}
          title={t('common:Download our app')}
          loading='lazy'
          width={148}
          height={48}
        />
      </a>
    );
  };

  return <ul className={styles.list}>{links?.map(renderStore)}</ul>;
};

export default StoreList;
